/**
 * Версия приложения
 * Обновляется при каждом релизе
 */
export const APP_VERSION = "2.4.20";
export const APP_UPDATE_TIME = "13:23 02.07.2026"

